
<template>
	<div class="container1">
		<div class="exclusive-search" :style="collapse ? 'height: 40px' : ''">
			<div class="search-box">
				<div class="input-box">
					<span>使用状态：</span>
					<el-select v-model="useStatus" class="select-box" size='mini'>
						<el-option :value="0" label="全部"></el-option>
						<el-option :value="1" label="使用中"></el-option>
					</el-select>
				</div>
				<div class="input-box">
					<span>商品名称：</span>
					<el-input
						v-model="pName"
						placeholder="请输入商品、规格名称"
						class="name-input"
						@keyup.enter.native="search"
						size="mini"
					></el-input>
				</div>
				<div class="input-box">
					<span>SPU编号：</span>
					<el-input
						v-model="pcode"
						placeholder="请输入SPU编号"
						class="name-input"
						@keyup.enter.native="search"
						size="mini"
					></el-input>
				</div>
				<div class="input-box">
					<span>三方编号：</span>
					<el-input
						v-model="matchcode"
						placeholder="请输入三方编号"
						class="name-input"
						@keyup.enter.native="search"
						size="mini"
					></el-input>
				</div>
				<div class="input-box">
					<span>SKU编号：</span>
					<el-input
						v-model="speccode"
						placeholder="请输入SKU编号"
						class="name-input"
						@keyup.enter.native="search"
						size="mini"
					></el-input>
				</div>
				<div class="input-box" v-if="!(matchbillcenterflag === 1 && matchbillcenterpriceflag ==1)">
					<span>销售门店：</span>
					<el-select
						size="mini"
						class="name-input"
						popper-class="select"
						v-model="shopNameIds"
						filterable
						multiple
						collapse-tags
						placeholder="请选择门店名称">
						<template v-for="item in shopList">
							<el-option
								:key="item.id"
								:label="item.name"
								:value="item.id">
							</el-option>
						</template>
					</el-select>
				</div>
				<div class="input-box">
					<span>新建人：</span>
					<el-input
						v-model="createUserName"
						placeholder="请输入新建人姓名"
						class="name-input"
						@keyup.enter.native="search"
						size="mini"
					></el-input>
				</div>
				<div class="input-box">
					<span>客户状态：</span>
					<el-select v-model="disabledflag" class="select-box" size='mini'>
						<el-option :value="null" label="全部"></el-option>
						<el-option :value="0" label="启用"></el-option>
						<el-option :value="1" label="停用"></el-option>
					</el-select>
				</div>
				<div class="time-box">
					<el-select v-model="dateType" class="select-input" size='mini'>
						<el-option :value="0" label="生效日期"></el-option>
						<el-option :value="1" label="失效日期"></el-option>
						<el-option :value="2" label="修改时间"></el-option>
						<el-option :value="3" label="新建时间"></el-option>
					</el-select>
					<el-date-picker
						v-model="dateValue"
						@change="timeChange"
						class="time-input"
						size="mini"
						type="datetimerange"
						:unlink-panels='true'
						range-separator="至"
						start-placeholder="开始日期"
						end-placeholder="结束日期"
						:default-time="['00:00:00', '23:59:59']"
						format='yyyy-MM-dd HH:mm'
						value-format='yyyy-MM-dd HH:mm:ss'>
					</el-date-picker>
				</div>
				<div v-show="matchbillcenterpriceflag !== 1" class="time-box1">
					<el-select v-model="warningState" class="select-input" style="margin-right: 5px;" size='mini'>
						<el-option :value="null" label="全部"></el-option>
						<el-option :value="1" label="预警"></el-option>
						<el-option :value="0" label="正常"></el-option>
						<el-option :value="2" label="已失效"></el-option>
					</el-select>
					<span style="margin: 0 5px">预警天数区间（天）</span>
					<el-input
						@blur="leastWarningDaysBlur"
						v-model="leastWarningDays"
						placeholder="最少天数"
						class="name-input"
						@keyup.enter.native="search"
						size="mini"
					></el-input>
					——
					<el-input
						@blur="mostWarningDaysBlur"
						v-model="mostWarningDays"
						placeholder="最多天数"
						class="name-input"
						@keyup.enter.native="search"
						size="mini"
					></el-input>
				</div>
			</div>
			<div class="input-box-btn">
				<el-button size="small" type="text" class="btn" @click="handleCollapse">
					{{ collapse ? '展开' : '收起' }}
					<i class="el-icon--right" :class="collapse ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"/>
				</el-button>
				<el-button type='primary' size='mini' class="fx-btn" @click="search">查询</el-button>
				<el-button plain size='mini' class="fx-btn" @click="clear">清空</el-button>
			</div>
		</div>
		<div class="btn-price-box">
			<el-button v-if='AuthorityList["03_0004_0003_00"] && !(matchbillcenterpriceflag === 1 && matchbillcenterflag ===1)' type='primary' size='mini' class="fx-big-btn" @click="addClick">添加商品</el-button>
			<el-button v-if='AuthorityList["03_0004_0004_00"] && !(matchbillcenterpriceflag === 1 && matchbillcenterflag ===1)' :disabled="!onlyOne" type='primary' plain size='mini' @click='copyClick'>复制到其他客户</el-button>
			<el-button v-if='AuthorityList["03_0004_0002_00"] && !(matchbillcenterpriceflag === 1 && matchbillcenterflag ===1)' type='primary' plain size='mini' @click='mutiCLick'>批量设置</el-button>
			<el-button v-if='AuthorityList["03_0004_0005_00"] && !(matchbillcenterpriceflag === 1 && matchbillcenterflag ===1)' type='primary' plain size='mini' @click="deleteList" class="fx-big-btn">删除</el-button>
			<el-button v-if='AuthorityList["03_0004_0006_00"] && !(matchbillcenterpriceflag === 1 && matchbillcenterflag ===1)' type='primary' plain size='mini' @click="deleteLists" class="fx-big-btn">批量删除</el-button>
			<el-button v-if='AuthorityList["03_0004_0008_00"]' type='primary' plain size='mini'  @click="downloadClick">
				导出
			</el-button>

			<el-button v-if='AuthorityList["03_0004_0007_00"] && !(matchbillcenterpriceflag === 1 && matchbillcenterflag ===1)' type='primary' plain size='mini' @click="fileClick">
				导入
			</el-button>
			<input type="file" ref="file" id="file" accept=".xlsx" v-show="false" @change="getFile">
		</div>
		<div class='table-box'>
			<el-table
				size='mini'
				class="grid-content"
				:data="tableData"
				@row-dblclick='rowClick'
				:height="tableHeight"
				ref="table"
				@selection-change="handleSelectionChange"
				border>
				<el-table-column
					type="selection"
					align="center"
					width="55">
				</el-table-column>
				<el-table-column
					label="客户类别"
					prop='cusCate'
					min-width="180"
					align="center">
				</el-table-column>
				<el-table-column
					label="客户名称"
					prop='cusName'
					min-width="180"
					align="center">
				</el-table-column>
				<el-table-column
					label="商品名称"
					prop='pname'
					min-width="180"
					align="center">
				</el-table-column>
				<el-table-column
					label="SPU编号"
					prop='pcode'
					min-width="180"
					align="center">
				</el-table-column>
				<el-table-column
					label="三方编号"
					prop='matchcode'
					min-width="180"
					align="center">
				</el-table-column>
                <el-table-column
					label="规格名称"
					prop='spec'
					min-width="180"
					align="center">
				</el-table-column>
				<el-table-column
					label="SKU编号"
					prop='speccode'
					min-width="180"
					align="center">
				</el-table-column>
				<el-table-column
					label="默认价格"
					prop='defaultprice'
					min-width="180"
					align="center">
				</el-table-column>
				<el-table-column
					label="专用价格"
					prop='speprice'
					min-width="180"
					align="center">
				</el-table-column>
				<el-table-column
					label="生效日期"
					prop='startdate'
					min-width="180"
					align="center">
				</el-table-column>
				<el-table-column
					label="失效日期"
					prop='enddate'
					min-width="180"
					align="center">
				</el-table-column>
				<el-table-column
					label="修改时间"
					prop='modifydate'
					min-width="180"
					align="center">
				</el-table-column>
				<el-table-column
					label="使用状态"
					prop='useing'
					min-width="180"
					align="center">
				</el-table-column>
				<el-table-column
					label="店铺名称"
					prop='shopname'
					min-width="180"
					align="center">
					<template slot-scope="scope">
						<el-button size="mini" type='text'>{{scope.row.shopname}}</el-button>
					</template>
				</el-table-column>
				<el-table-column
					label="新建时间"
					prop='createDate'
					min-width="180"
					align="center">
				</el-table-column>
				<el-table-column
					label="新建人"
					prop='createUserName'
					min-width="180"
					align="center">
				</el-table-column>
				<el-table-column
					v-show="matchbillcenterpriceflag !== 1"
					label="预警天数"
					prop='warningDays'
					min-width="180"
					align="center">
					<template slot-scope="scope">
						<span v-if="scope.row.warningDays !== -1">{{scope.row.warningDays}}</span>
					</template>
				</el-table-column>
				<el-table-column
					v-show="matchbillcenterpriceflag !== 1"
					label="预警状态"
					prop='warningState'
					min-width="180"
					align="center">
					<template slot-scope="scope">
						<span v-if="scope.row.warningState === 0">正常</span>
						<span style="color: red" v-if="scope.row.warningState === 1">预警</span>
						<span v-if="scope.row.warningState === 2">失效</span>
					</template>
				</el-table-column>
				<el-table-column fixed="right" label="操作" width="200" align="center">
					<template slot-scope="scope">
						<el-button size="mini" type='text' @click="show(scope.row)">查看</el-button>
						<el-button size="mini" type='text' v-if='AuthorityList["03_0004_0005_00"] && !(matchbillcenterpriceflag === 1 && matchbillcenterflag ===1)' @click="deleteClick(scope.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-dialog class="detail-dialog-title" title="添加商品" top='60px' :before-close='closeAdd' :visible.sync="addModal" width='1400px' :close-on-click-modal="false">
				<addGood :addModal='addModal' :customerName='customerName' :customerId='cusId' @cancel='closeAdd'/>
			</el-dialog>
			<el-dialog class="detail-dialog-title" title="批量设置" top='60px' :before-close='cancelMuti' :visible.sync="mutiModel" width='500px' :close-on-click-modal="false">
				<Muti v-if='mutiModel' :ids='ids' :tableData="tableData" @cancel='cancelMuti'></Muti>
			</el-dialog>
			<el-dialog class="detail-dialog-title" title="批量删除" top='60px' :before-close='closeDelete' :visible.sync="deleteModal" width='500px' :close-on-click-modal="false">
				<BatchDeletion :deleteModal='deleteModal' v-if="deleteModal" @cancel='closeDelete'/>
			</el-dialog>
			<el-dialog class="detail-dialog-title" title="复制到其他客户" top='60px' :before-close='closeCopy' :visible.sync="copyModal" width='1200px' :close-on-click-modal="false">
				<copy :copyModal='copyModal' :ppIds='ids' :copyFlag='copyFlag' @cancel='closeCopy' ref="refCopy"/>
			</el-dialog>
			<el-dialog class="detail-dialog-title" title="编辑" top='60px' :before-close='closeEdit' :visible.sync="editModal" width='500px' :close-on-click-modal="false">
				<Edit :editModal='editModal' :isDisabled='!AuthorityList["03_0004_0002_00"]' :editData='editData' @cancel='closeEdit'/>
			</el-dialog>
			<el-dialog title="提示" class="detail-dialog-title" top='60px' :visible.sync="errorMsgModel" width='400px' :close-on-click-modal="false">
			<div style="margin-bottom:10px;max-height:250px;overflow:auto">
				<div class="errormsgText" v-for="(item,index) in errorMsgList" :key='index' >
					{{item}}
				</div>
			</div>
		</el-dialog>
		</div>
		<div style="margin-top:5px">
			<el-pagination
			@size-change="handleSizeChange"
			@current-change="handlePageChange"
			:current-page="page.num"
			:page-sizes="[20,40, 60, 100, 300]"
			:page-size="page.size"
			layout="total, sizes, prev, pager, next, jumper"
			:total="total">
			</el-pagination>
		</div>
	</div>
</template>
<script>
import addGood from '@/components/exclusivePrice/addGood.vue'
import copy from '@/components/exclusivePrice/copy.vue'
import Edit from '@/components/exclusivePrice/Edit.vue'
import Muti from '@/components/exclusivePrice/Muti.vue'
import BatchDeletion from '@/components/exclusivePrice/BatchDeletion.vue'
export default {
	name: 'table-box',
	components: {
		addGood, copy, Edit, BatchDeletion, Muti
	},
	props: {
	},
	data () {
		return {
			params: {},
			errorMsgModel: false,
			errorMsgList: [],
			customerName: '',
			startdate: '',
			enddate: '',
			addModal: false,
			deleteModal: false,
			copyModal: false,
			editModal: false,
			editData: '',
			dateValue: [],
			dateType: 0,
			useStatus: 1,
			name: '',
			shopName: '',
			pName: '',
			tableHeight: '100%',
			page: {
				size: 20,
				num: 1
			},
			total: 0,
			tableData: [],
			AuthorityList: {
				'03_0004_0001_00': false,
				'03_0004_0002_00': false,
				'03_0004_0003_00': false,
				'03_0004_0004_00': false,
				'03_0004_0005_00': false,
				'03_0004_0006_00': false,
				'03_0004_0007_00': false,
				'03_0004_0008_00': false
			},
			pcode: '',
			matchcode: '',
			speccode: '',
			matchbillcenterflag: 0,
			matchbillcenterpriceflag: 0,
			shopNameIds: [],
			shopList: [],
			mutiModel: false,
			copyFlag: 0,
			createUserName: '',
			cusId: '',
			cusLevelId: '',
			cusCategoryId: '',
			keyword: '',
			ids: [],
			onlyOne: true,
			leastWarningDays: '',
			mostWarningDays: '',
			warningState: null,
			disabledflag: null,
			collapse: false
		}
	},
	created () {
		if (this.$route.query.isWaring) {
			this.$fxEventBus.$emit('setMenu', '5-3')
			this.warningState = 1
			this.useStatus = 0
			this.dateValue = []
		}
		this.checkSmallCategory()
		this.getAuthority('03_0004_0000_00')
		this.getShopList()
	},
	computed: {
	},
	methods: {
		handleCollapse () {
			this.collapse = !this.collapse
		},
		leastWarningDaysBlur () {
			if (this.leastWarningDays !== '') {
				this.leastWarningDays = this.$fxUtils.toFixedSHW(this.leastWarningDays, 0)
			}
		},
		mostWarningDaysBlur () {
			if (this.mostWarningDays !== '') {
				this.mostWarningDays = this.$fxUtils.toFixedSHW(this.mostWarningDays, 0)
			}
		},
		changeData (data, flag) {
			this.cusId = data.cusId
			this.cusLevelId = data.cusLevelId
			this.cusCategoryId = data.cusCategoryId
			this.keyword = data.keyword
			this.customerName = data.cusName
			this.page = {
				size: 20,
				num: 1
			}
			this.total = 0
			this.tableData = []
			if (flag) {
				this.tableReload()
			} else {
				this.$message({
					message: '请点击查询获取数据！',
					type: 'warning'
				})
			}
			// this.tableReload()
		},
		cancelMuti (data) {
			this.mutiModel = false
			this.tableReload()
		},
		mutiCLick () {
			if (this.ids.length === 0) {
				this.$message.error('请选择至少一个商品！')
				return false
			}
			this.mutiModel = true
		},
		// 是否对接中台
		checkSmallCategory () {
			// return new Promise((resolve, reject) => {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/systemcenter/matchorganinfo/checkSmallCategoryIsUser`
			}).then(res => {
				this.matchbillcenterflag = res.matchbillcenterflag
				this.matchbillcenterpriceflag = res.matchbillcenterpriceflag
			})
			// })
		},
		fileClick () {
			this.$refs.file.dispatchEvent(new MouseEvent('click'))
		},
		errorMsgClick () {
			this.errorMsgModel = false
		},
		getFile (e) {
			let files = e.target.files[0]
			console.log(files)
			this.uploadExcelHandle()
			this.$refs.file.value = ''
		},
		uploadExcelHandle () {
			return new Promise((resolve, reject) => {
				var formData = new FormData()
				formData.append('file', this.$refs.file.files[0])
				this.$store.dispatch('requestFilePost', {
					url: `${this.$fxBaseApi.newExportUrl}/customer/importCustomerPriceExcel?syscodeid=0`,
					data: formData
				}).then(res => {
					if (res.result) {
						this.$message.success('导入成功！')
						this.tableReload()
					} else {
						this.errorMsgList = res.data
						this.errorMsgModel = true
					}
				})
			})
		},
		downloadClick () {
			const req = new XMLHttpRequest()
			let _this = this
			req.open('POST', `${this.$fxBaseApi.newExportUrl}/customer/exportCustomerDetailPriceExcel`, true)
			req.responseType = 'blob'
			req.setRequestHeader('Content-Type', 'application/json')
			req.setRequestHeader('pname', 'bc2ff5388144d30e137b28acafd39795')
			req.setRequestHeader('shiroSession', window.sessionStorage.getItem('shiroSession'))
			req.onload = function () {
				const data = req.response
				const blob = new Blob([data])
				const blobUrl = window.URL.createObjectURL(blob)
				_this.download(blobUrl)
			}
			let params = this.params
			let list = this.initIds(this.ids)
			if (this.ids.length > 0) {
				params.priceIds = list
			} else {
				params.priceIds = []
			}
			req.send(JSON.stringify(params))
		},
		download (blobUrl) {
			const a = document.createElement('a')
			a.style.display = 'none'
			var date = new Date()
			var year = date.getFullYear()
			var month = date.getMonth() + 1
			var day = date.getDate()
			let name = '客户价格信息(' + year + '-' + month + '-' + day + ').xlsx'
			a.download = name
			a.href = blobUrl
			a.click()
		},
		rowClick (row, column, event) {
			this.show(row)
		},
		getAuthority (pid) {
			let params = {
				pId: pid
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
				}
			})
		},
		timeChange () {
			if (this.dateValue === null) {
				this.startdate = ''
				this.enddate = ''
			} else {
				this.startdate = this.dateValue[0]
				this.enddate = this.dateValue[1]
			}
		},
		closeEdit () {
			this.editModal = false
			this.tableReload()
		},
		closeAdd () {
			this.addModal = false
			this.page = {
				size: 20,
				num: 1
			}
			this.tableReload()
		},
		closeDelete () {
			this.deleteModal = false
			this.tableReload()
		},
		closeCopy () {
			this.copyModal = false
			this.$refs.refCopy.name = ''
			this.$refs.refCopy.lineName = ''
			this.$refs.refCopy.customercategoryid = -1
			this.$refs.refCopy.disabledflag = 2
			this.page = {
				size: 20,
				num: 1
			}
			this.tableReload()
		},
		copyClick () {
			if (this.ids.length === 0) {
				this.$message.error('请选择至少一个商品价格档案！')
				return false
			}
			this.copyModal = true
		},
		addClick () {
			if (this.cusId === '') {
				this.$message.error('请选择客户')
				return false
			} else {
				this.addModal = true
			}
		},
		deleteLists () {
			this.deleteModal = true
		},
		show (data) {
			this.editModal = true
			this.editData = data
		},
		search () {
			if ((this.mostWarningDays !== '' && this.leastWarningDays !== '') && (+this.mostWarningDays < +this.leastWarningDays)) {
				this.$message.error('您输入的最多天数小于输入的最少天数，请您重新输入')
				return false
			}
			this.page = {
				size: 20,
				num: 1
			}
			this.tableReload()
		},
		clear () {
			this.useStatus = 1
			this.pName = ''
			this.pcode = ''
			this.matchcode = ''
			this.speccode = ''
			this.shopNameIds = []
			this.createUserName = ''
			this.dateType = 0
			this.dateValue = []
			this.warningState = null
			this.disabledflag = null
			this.leastWarningDays = ''
			this.mostWarningDays = ''
			this.page = {
				size: 20,
				num: 1
			}
			this.tableReload()
		},
		deleteClick (data) {
			let params = {
				spids: data.id
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/delCustomerSpecialPrice`,
				data: params
			}).then(res => {
				// console.log(res)
				if (res.result) {
					this.tableReload()
					this.$message.success('删除成功！')
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		deleteList (data) {
			if (this.ids.length === 0) {
				this.$message.error('请选择至少一个商品价格档案！')
				return false
			}
			let list = this.initIds(this.ids)
			let params = {
				spids: list.join(',')
			}
			let textArr = []
			this.ids.forEach(item => {
				let text = ('客户【' + item.cusName + '】删除了商品【' + item.pname + '】')
				textArr.push(text)
			})
			let changeData = {
				info: textArr.join(',')
			}
			const logger = this.$fxLogger.createInfo('custom.custom-else.del', changeData)
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/delCustomerSpecialPrice`,
				data: params,
				logger
			}).then(res => {
				if (res.result) {
					this.tableReload()
					this.$message.success('删除成功！')
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		initIds (data) {
			let list = []
			data.forEach(item => {
				list.push(item.id)
			})
			return list
		},
		handleSelectionChange (data) {
			this.ids = data
			let arr = data.map(item => {
				return item.oneid
			})
			let length = new Set(arr).size
			if (length > 1) {
				this.onlyOne = false
			} else {
				this.onlyOne = true
			}
		},
		tableReload () {
			let params = {
				useStatus: this.useStatus,
				dateType: this.dateType,
				startdate: this.startdate,
				enddate: this.enddate,
				shopname: this.shopName,
				productname: this.pName,
				page: this.page.num,
				size: this.page.size,
				pcode: this.pcode,
				matchcode: this.matchcode,
				speccode: this.speccode,
				createUserName: this.createUserName,
				relShopIdList: this.shopNameIds,
				id: this.cusId,
				customercategoryid: this.cusCategoryId,
				customerlevelid: this.cusLevelId,
				keyword: this.keyword,
				leastWarningDays: this.leastWarningDays,
				mostWarningDays: this.mostWarningDays,
				disabledflag: this.disabledflag
			}
			if (this.warningState !== null) {
				params.warningState = this.warningState
			}
			this.params = params
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/getProductOfSpecialPrice`,
				data: params
			}).then(res => {
				if (res.result) {
					this.tableData = res.data.recordList
					if (res.data.recordList !== null) {
						this.tableData.forEach(item => {
							item.defaultprice = item.defaultprice === -1 ? '' : this.$fxUtils.toFixedSHW(item.defaultprice, 2)
							item.speprice = item.speprice === -1 ? '' : this.$fxUtils.toFixedSHW(item.speprice, 2)
						})
					}
					this.total = +res.data.recordCount
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		handleSizeChange (val) {
			this.page.size = val
			this.tableReload()
		},
		handlePageChange (val) {
			this.page.num = val
			this.tableReload()
		},
		getShopList () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/selectShopList`
			}).then(res => {
				this.shopList = res
				// console.log(res)
			})
		}
	}
}
</script>
<style lang="stylus" scoped>
.container1{
	width:100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	.errormsgText{
		width:100%;
		text-align :left
		line-height:30px;
	}
	.batch-register-btn{
		color: var(--fx-primary-color);
		background: #ecf5ff;
		border-color: #b3d8ff;
		border-radius: 4px;
		cursor :pointer;
		font-size: 12px;
		margin-left: 10px;
		display: flex;
		width: 100px;
		justify-content center;
		align-items center;
	}
	.excel-icon {
		display inline-block
		height 20px
		width 20px
		background-repeat no-repeat
		background-position center
		&.import-excel-icon {
			background-image: url('~images/icon/import-excel-icon.png')
		}
		&.export-excel-icon {
			background-image: url('~images/icon/export-excel-icon.png')
		}
	}
	.exclusive-search {
		padding-bottom :5px;
		line-height: 35px;
		width:100%;
		display:flex;
		border-bottom 1px solid #dce2fd
	}
	.search-box{
		display:flex;
		flex-wrap:wrap;
		overflow: hidden;
        .select-input{
			width :95px
		}
		.time-input{
			margin-left 10px
			width :330px
		}
        .time-box{
			text-align :left
            width :475px;
			margin-bottom:10px
			margin-right:10px
			.name-input {
				width: 100px;
			}
        }
		.time-box1{
			text-align :left
            width :500px;
			margin-bottom:10px
			margin-right:10px
			.name-input {
				width: 100px;
			}
        }
		.input-box{
			text-align :left
			// width :280px;
			margin-bottom:10px
			span {
				display: inline-block;
				text-align: right;
				width: 100px;
				margin-right: 5px
			}
			.name-input {
				width: 180px;
				margin-right: 10px;
			}
			.select-box{
				width:180px;
				margin-right:10px;
			}
		}
	}
	.input-box-btn{
		width: 200px;
		// line-height: 50px;
		flex-shrink: 0
	}
	.name-box{
		padding-bottom :10px;
		margin-top :10px;
		width:100%;
		height :40px;
		line-height :40px;
		display:flex;
		flex-wrap:wrap;
		border-bottom 1px solid #dce2fd
		.input-box{
			text-align :left
			overflow-x :hidden
			margin-bottom:10px
		}
	}
	.btn-price-box{
		margin-top:10px;
		display :flex
	}
	.table-box{
		margin-top:8px;
		min-height:200px;
		flex: 1;
	}
}

</style>
<style lang="stylus">
	.el-select__tags{
		height: 28px;
	}
	.cell{
		padding: 0 !important
	}
.el-dialog__header{
    text-align left
}
.el-dialog__body {
	padding: 10px 20px 10px 20px;
}
.select {
	min-width: 280px !important
}
</style>
